<template>
  <section :class="['interior-style', { 'isWhiteBg': isWhiteBg }]" id="interior-style-section">
    <div v-if="visible" class="content">
      <h1 :class="{ 'font-weight-bold': lang === 'ru' }" class="title" v-text="title ? title : translations[lang].title" />
      <p class="subtitle" v-text="subTitle ? subTitle : translations[lang].subtitle" />
      <div :class="['interior-style-container', { 'interior-style-container-wide': wideWidget }]" id="widget-styles-block">
        <div :class="['interior-style-container-frame', { noWidth: wideWidget }]" id="widget-styles-container">
          <iframe title="widget" :src="widget_url" width="100%" height="100%" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen oallowfullscreen msallowfullscreen async />
        </div>
      </div>

      <!-- Стиль дизайна интерьера -->
      <div class="interior-style__wrapper">
        <div class="interior-style__column">
          <p class="interior-style__title">
            <img alt="Interior design style" src="@/assets/img/interior-style/brush.svg" />
            {{ translations[lang].style_title }}
          </p>
          <div class="interior-style-container--styles interior-style-container--three-columns">
            <div v-for="(item, index) in style_items" :key="index" class="interior-style-container--styles-item">
              <input :checked="item.checked" :id="item.value" :value="item.value" name="style" type="radio" v-model="style" />
              <label :for="item.value" class="interior-style-container--styles-item--button">
                <img :alt="item.name" :src="require(`@/assets/img/interior-style/${item.icon}`)" />
                {{ item.name }}</label>
            </div>
          </div>
        </div>

        <!-- Вид из окна -->
        <div v-if="!hideWindowViewToolbar" class="interior-style__column">
          <p class="interior-style__title">
            <img alt="Window view" src="@/assets/img/interior-style/image.svg" />
            {{ translations[lang].view_title }}
          </p>
          <div class="interior-style-container--styles interior-style-container--three-columns">
            <div v-for="(item, index) in view_items" :key="index" class="interior-style-container--styles-item">
              <input :checked="item.checked" :id="item.value" :value="item.value" name="view" type="radio" v-model="view" />
              <label class="interior-style-container--styles-item--button" :for="item.value">{{ item.name[lang] }}</label>
            </div>
            <button @click="modals.openViewForm" class="interior-style-container--styles-item--button-view"><img alt="Window view" src="@/assets/img/interior-style/image.svg" />{{ translations[lang].button_view }}</button>
          </div>
        </div>

        <!-- Стоимость и сроки -->
        <div v-if="!hidePriceBlock" class="interior-style__column">
          <p class="interior-style__title">
            <img alt="Window view" src="@/assets/img/interior-style/ruble.svg" />
            Стоимость и сроки
          </p>
          <div class="interior-style-container--styles noGridGap"><Achievments /></div>
        </div>
      </div>
      <div class="interior-style__button-wrapper" v-if="showContactBtn && lang === 'ru'">
        <button @click="() => openCianForm()" class="custom-button interior-style__button">Оставить заявку</button>
      </div>
      <div class="interior-style__button-wrapper" v-if="hideButton">
        <button @click="handleOrderButtonClick" class="custom-button interior-style__button btn-place-order">{{ translations[lang].button_order }}</button>
      </div>
    </div>
  </section>
  <ViewFormModal :lang="lang" v-if="modals.isViewFormModalOpen" :close="modals.closeViewForm" :open-message="modals.openQuestionSuccess"></ViewFormModal>
</template>

<script>
import Achievments from '@/Components/En/Common/Achievments.vue';
import { widgetPlanIds } from '@/enums/widgetPlanIds';
import { styles } from '@/enums/styles';
import { roomTypes } from '@/enums/roomTypes';
import { views } from '@/enums/views';
import { useModals } from '@/composables/useModals';
import { getUtmParamsFromStorage } from '@/utils/utm';
import ViewFormModal from '../Modals/ViewFormModal.vue';

export default {
  name: 'InteriorStyle',
  components: {
    Achievments,
    ViewFormModal,
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    visible: {
      default: false,
      type: Boolean,
    },
    hideRoomToolbar: {
      default: false,
      type: Boolean,
    },
    hideWindowViewToolbar: {
      default: false,
      type: Boolean,
    },
    hidePriceBlock: {
      default: true,
      type: Boolean,
    },
    hideButton: {
      default: true,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
    subTitle: {
      default: '',
      type: String,
    },
    bottomBtnHandler: {
      default: () => {},
      type: Function,
    },
    openCianForm: {
      default: () => null,
      type: Function,
    },
    isWhiteBg: {
      type: Boolean,
      default: false,
    },
    showContactBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      translations: {
        en: {
          title: 'Try interior styles and window views',
          subtitle: 'Combine interior design styles and window views',
          style_title: 'Interior design style',
          view_title: 'Window view',
          button_view: 'My custom view',
          button_order: 'Place an order',
        },
        ru: {
          title: 'Выберите стиль и вид из окна',
          subtitle: 'Наш ИИ может показать разные виды из окна. Пробуйте!',
          style_title: 'Стиль дизайна интерьера',
          view_title: 'Вид из окна',
          button_view: 'Добавить свой вид',
          button_order: 'Загрузить планировку',
        },
      },
      style_items: styles,
      type_items: roomTypes,
      type: 'living',
      style: 'scandy',
      view: 'city',
      wideWidget: !!this.$props.hideRoomToolbar,
      view_items: views,
      widget_url: `${window.location.origin}/widget/?id=1d4bc3eb-6248-41e6-b9c5-715949199b28&type=living&style=scandy&lang=${this.lang}`,
      modals: useModals(),
    };
  },
  watch: {
    type() {
      this.change();
    },
    style() {
      this.change();
    },
    view() {
      this.change();
    },
  },
  methods: {
    handleOrderButtonClick() {
      if (this.lang === 'ru') {
        this.$router.push({
          path: '/',
          hash: '#showcase',
          query: { ...this.$route.query, ...getUtmParamsFromStorage() },
        });
      } else {
        const utm = getUtmParamsFromStorage();
        this.$router.push({
          path: '/pricing',
          query: { ...this.$route.query, ...utm },
        });
      }
    },
    change() {
      const id = `${widgetPlanIds[this.style][this.view]}`;

      this.widget_url = `${window.location.origin}/widget/?id=${id}&type=${this.type}&style=${this.style}&lang=${this.lang}`;
    },
  },
};
</script>
